import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { Logger } from 'angular2-logger/core';
import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
import { environment } from '../../environments/environment';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { DateTime } from 'luxon';

import { Router } from '@angular/router';

export function securePasswordValidator(control: AbstractControl): ValidationErrors | null {
	const value: string = control.value;

	if (!value) return null;

	const hasUpperCase = /[A-Z]/.test(value);
	const hasLowerCase = /[a-z]/.test(value);
	const hasNumber = /[0-9]/.test(value);
	const hasSpecialChar = /[!-/:-@[-`{-~]/.test(value);
	const isLongEnough = value.length >= 10;

	const passwordValid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isLongEnough;

	return passwordValid ? null : {
		securePassword: {
			hasUpperCase,
			hasLowerCase,
			hasNumber,
			hasSpecialChar,
			isLongEnough
		}
	};
}

@Injectable()
export class SharedService {

	public baseUrl: string;
	public user: any;
	public role_id: any;
	public user_id: any;
	public state_agent: any;
	public cond: any;
	public archived_route: boolean;
	public routeTab: string;
	public datoUsuario: any;
	public statusVideocall: boolean;

	private dataSubject = new BehaviorSubject<any>(null);
	public data$ = this.dataSubject.asObservable();

	private subjectVideocall = new BehaviorSubject<any>(null);
	public videocall$ = this.subjectVideocall.asObservable();

	constructor(
		private _http: Http,
		private logger: Logger,
		public _router: Router,
		@Inject(LOCAL_STORAGE) private storage: WebStorageService
	) {
		this.baseUrl = environment.apiUrl;
		this.cond = {
			isAdmin: true,
			agent_id: null,
			name_agent: null
		};
	}

	initUser(firstTimeValidate : boolean,loginFirstTime: any) {
		// gets users data and redirects.
		let data = {
			auth_token: this.getCookie("auth_token")
		};

		this.getCurrent(data).subscribe(
			data => {
				if (data.status) {
					this.logger.log(data.data);
					this.user = data.data;
					this.user_id = this.user.id;
					this.role_id = this.user.role_id;
				} else {
					this.logger.log(data.message);
				}
				
				if (loginFirstTime == 1 || firstTimeValidate == true) {
					this._router.navigate(['/dashboard/changepassword', {}]);
				}else{
					if (this.role_id == '1' || this.role_id == '5') {
						this._router.navigate(['/admin/listado', {}]);
					}else{
						this._router.navigate(['/dashboard', {}]);
					}
				}
				
			},
			error => {
				this.logger.log(error);

			}
		);

	}

	getCurrent(data: any) {
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'user/profile', { headers: headers })
			.map(res => res.json());
	}

	getDataUser(data: any) {
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'user/getDataUser/' + data.id, { headers: headers })
			.map(res => res.json());
	}

	getTienda(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/getTienda', json, { headers: headers })
			.map(res => res.json());
	}

	getStatusUsers(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/getStatusUsers', json, { headers: headers })
			.map(res => res.json());
	}

	getStatusConetion(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/status-contetion', json, { headers: headers })
			.map(res => res.json());
	}

	updateStatus(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/update-status', json, { headers: headers })
			.map(res => res.json());
	}


	getCookie(name) {
		var nameEQ = encodeURIComponent(name) + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ')
				c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0)
				return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
		return null;
	}

	setCookie(cname, cvalue, exdays, domain) {
		//  exdays = -1,  to delete  cookie.|  exdays = null, to inifinite.
		if (exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=" + domain + ";path=/";
		} else {
			document.cookie = cname + "=" + cvalue + ";domain=" + domain + ";path=/";
		}
	}

	logout() {
		let data = {
			auth_token: this.getCookie("auth_token")
		};
		//this.storage.remove('Usuario');
		//this.storage.remove('pusherTransportTLS');
		//console.log(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/logout', null, { headers: headers })
			.map(res => res.json());
	}

	checkingForFlagChanged() {
		let data = {
			auth_token: this.getCookie("auth_token")
		};
		//console.log(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/checkingForFlagChanged', null, { headers: headers })
			.map(res => res.json());
	}

	public setAgentToLogout(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		//console.log("Esto es lo que se le envía al servidor: ", json);
		return this._http.post(this.baseUrl + 'changeFlag', data, { headers: headers }).map(res => res.json());
	}

	toggleStatus(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'user/online', json, { headers: headers })
			.map(res => res.json());
	}

	toggleStatusCloseRooms(data: any) {
		//console.log(data);
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'room/status-change', json, { headers: headers })
			.map(res => res.json());
	}

	getIds(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'getData', json, { headers: headers }).map(res => res.json());
	}

	public getCategorias(data) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'list/categorias', data, { headers: headers })
			.map(res => res.json());
	}

	blockSupervisor(user_id: number, name_agent: boolean) {
		this.cond.isAdmin = true;
		this.cond.agent_id = user_id;
		this.cond.name_agent = name_agent;
	}

	activateBlockSupervisor() {
		return this.cond;
	}

	routeTabArchived(route) {
		return this.routeTab = route;
	}

	activateRouteTabArchived() {
		return this.routeTab;
	}

	ChangeStatus(status) {
		//console.log(status);
		return this.state_agent = status;
	}

	public getLastToken(user_id) {
		let data = {
			auth_token: this.getCookie("auth_token"),
			user_id: user_id
		};
		console.log("Entramos a la petición enviada de getlast Token");
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		console.log("Estos son los headers que envío: ", headers);

		return this._http.post(this.baseUrl + 'user/getLastToken', data, { headers: headers })
			.map(res => res.json());

	}

	public normalize(value: any): string {
		return (value === null || value === undefined || value === "null") ? '' : value;
	}


	public getInfoPanel(data) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'get-info-panel', data, { headers: headers })
			.map(res => res.json());
	}

	public guardarInfoPanel(data) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'save-info-panel', data, { headers: headers })
			.map(res => res.json());
	}

	public cerrarPendientes(data) {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		return this._http.post(this.baseUrl + 'jobsSchedulerCloseRooms', data, { headers: headers })
			.map(res => res.json());
	}

	async secondLogOut(data2) {
		let data = {
			auth_token: this.getCookie("auth_token"),
			user_id: data2.user_id
		};
		console.log("Entramos a la petición enviada");
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		console.log("Estos son los headers que envío: ", headers);
		return await this._http.post(this.baseUrl + 'user/secondLogOut', data, { headers: headers })
			.map(res => res.json()).toPromise();

	}

	convertirZonaHoraria(ultimoMsj: string, time_zone: string, time_zone_sistem: string) {
		//console.log('valdacion de hora', ultimoMsj, time_zone, time_zone_sistem)

		const fechaOriginal = DateTime.fromJSDate(new Date(ultimoMsj));
		//const fechaFormateada = fechaOriginal.toISOString();
		const fechaFormateada = fechaOriginal.toFormat("yyyy-MM-dd'T'HH:mm:ss");
		//console.log('Fecha SISTEMA formateada :', fechaFormateada);
		// fecha del sistema
		const fecha_sistem = DateTime.fromISO(fechaFormateada, { zone: time_zone_sistem });
		//console.log('Fecha SISTEMA:', fecha_sistem.toISO());

		// Convierte la fecha a la zona horaria de usuario
		const time_zone_user = fecha_sistem.setZone(time_zone);

		//console.log('Fecha backend:', fechaColombia.toISO());
		//console.log('Fecha Usuario:', time_zone_user.toISO());
		const fechaMostar = time_zone_user.toFormat("yyyy-MM-dd HH:mm:ss");
		return (fechaMostar)
	}

	compararZonasHorarias(time_zone1: string, time_zone2: string): string {
		const fechaActual = DateTime.local();

		const offset1 = fechaActual.setZone(time_zone1).offset;
		const offset2 = fechaActual.setZone(time_zone2).offset;

		if (offset1 > offset2) {
			return 'es mayor que';
		} else if (offset1 < offset2) {
			return 'es mayor que';
		} else {
			return 'iguales';
		}
	}

	public uploadAudio(formData: FormData, authToken: string) {
		let headers = new Headers();
		headers.append('Accept', 'application/json'); 
		headers.append('Authorization', 'Bearer ' + authToken);
	
		return this._http.post(this.baseUrl + 'room/upload-audio', formData, { headers: headers })
			.map(res => res.json());
	}
	

	//Subjects
	updateData(data: { id: number; detalle: string }) {
		this.dataSubject.next(data);
	}

	runVideocall(data: { meeting_id: string, name_user: string, recording: boolean }) {
		this.subjectVideocall.next(data);
	}

	//scripts
	getInfoScripts(data: any) {
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.get(this.baseUrl + 'info-scripts', { headers: headers })
			.map(res => res.json());
	}

	createScript(data: FormData) {
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.get('auth_token'));
	
		return this._http.post(this.baseUrl + 'createScript', data, { headers: headers }).map(res => res.json());
	}
	

	updateScript(data: FormData) {
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.get('auth_token'));
		
		return this._http.post(this.baseUrl + 'updateScript', data, { headers: headers }).map(res => res.json());
	}

	deleteScript(data: any) {
		let headers = new Headers();
		
		return this._http.post(this.baseUrl + 'deleteScript', data, { headers: headers }).map(res => res.json());
	}
	
	scriptById(data: any) {
		let headers = new Headers();
		headers.append('Authorization', 'Bearer ' + data.auth_token);
		headers.append('Content-Type', 'application/json');
	
		let json = JSON.stringify(data);
	
		return this._http.post(this.baseUrl + 'scriptById', json, { headers: headers })
			.map(res => res.json());
	}
	
	getHistoryAudit(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'history-audit', json, { headers: headers })
			.map(res => res.json());
	}

	getHistoryAuditExcel(data: any) {
		let json = JSON.stringify(data);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + data.auth_token);

		return this._http.post(this.baseUrl + 'history-audit-excel', json, { headers: headers })
			.map(res => res.json());
	}
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/shared.service.ts